var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('table',[_c('tr',{staticClass:"table-row"},[_c('td'),_vm._v(" "),_vm._l((_vm.cols),function(col){return _c('th',[_vm._v("\n        "+_vm._s(col.title)+"\n      ")])})],2),_vm._v(" "),_vm._l((_vm.rows),function(row){return _c('tr',{staticClass:"table-row"},[_c('th',[_vm._v(_vm._s(row.title))]),_vm._v(" "),_vm._l((_vm.data[row.index]),function(v){return _c('td',[_vm._v(_vm._s(v))])})],2)})],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c11e008a","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Cross-Table.vue
// module id = 747
// module chunks = 1